// AI caption drafting — the WAIT LABEL.
//
// ⚠️ The timer itself now lives in src/lib/useElapsedSeconds.ts and is SHARED
// with the Franchise Campaign copy workspace: a second implementation would be a
// second thing to get wrong about throttled background tabs. What stays here is
// the LABEL, because an honest wait message has to name this feature's own slow
// part and its own expectation — a campaign-copy run takes considerably longer
// than a caption one, and telling either "about 25 seconds" would be a lie half
// the time.
//
// ⚠️ Re-exported so the existing importers (and the on-demand source-shape
// guard's reasoning about where effects live) are unchanged.
export { useElapsedSeconds } from '../../lib/useElapsedSeconds';

/** Rough expectation shown to the user. Opus + reference fetching. */
export const CAPTION_DRAFT_EXPECTED_SECONDS = 25;

/**
 * What to say while waiting. Honest at every stage: it names the slow part, and
 * once past the expectation it says so rather than pretending it is nearly done.
 */
export function draftingWaitLabel(seconds: number): string {
  if (seconds < 3) return 'Reading your references…';
  if (seconds < CAPTION_DRAFT_EXPECTED_SECONDS) return `Writing — about 25 seconds (${seconds}s)`;
  return `Still writing (${seconds}s) — longer than usual, but it is still going`;
}
